import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import ProtectedButton from "../RBAC/ProtectedButton";

export default function InitiateProjectModal({
    show,
    onClose,
    onSave,
    paymentValue,
    setPaymentValue
}) {
    const [isDisabled, setIsDisabled] = useState(false);

    if (!show) return null;

    const handleSave = () => {
        onSave();
    };

    return (
        <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{
                background: "rgba(0,0,0,0.5)",
                backdropFilter: "blur(4px)",
                zIndex: 1200,
            }}
            onClick={onClose}
        >
            <div
                className="modal-dialog modal-dialog-centered"
                style={{ maxWidth: "500px", width: "90%" }}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    className="modal-content p-5 rounded-4 shadow"
                    style={{
                        background: "#fff",
                        borderRadius: "12px",
                        padding: "20px",
                        width: "100%",
                        maxWidth: "500px",
                    }}
                >
                    <h4 className="fw-bold mb-3" style={{ color: "#071437" }}>
                        Please Enter Total Project Value
                    </h4>

                    <Form.Group className="mb-4">
                        <Form.Label
                            htmlFor="paymentValue"
                            className="fw-semibold"
                            style={{ color: "#181D4C" }}
                        >
                            Payment Value (USD)
                        </Form.Label>
                        <Form.Control
                            id="paymentValue"
                            type="number"
                            placeholder="Enter amount in USD"
                            value={paymentValue}
                            onChange={(e) => setPaymentValue(e.target.value)}
                            style={{
                                height: "44px",
                                border: "1px solid #d2ccccff",
                                borderRadius: "6px",
                            }}
                        />
                    </Form.Group>

                    <div className="d-flex justify-content-end gap-3 mt-4">
                        <ProtectedButton
                            permission="initiateProject"
                            variant="outline-secondary"
                            className="px-4"
                            onClick={() => {
                                setPaymentValue("");
                                onClose();
                            }}
                            style={{
                                minWidth: "120px",
                                height: "44px",
                                borderRadius: "8px",
                            }}
                        >
                            Cancel
                        </ProtectedButton>

                        <ProtectedButton
                            permission="initiateProject"
                            className="px-4"
                            style={{
                                backgroundColor: "#181D4C",
                                color: "#fff",
                                minWidth: "120px",
                                height: "44px",
                                borderRadius: "8px",
                            }}
                            disabled={!paymentValue || isDisabled}
                            onClick={() => {
                                setIsDisabled(true);
                                handleSave();
                            }}
                        >
                            Save
                        </ProtectedButton>
                    </div>
                </div>
            </div>
        </div>
    );
}
